import { getDataFetcher } from "../../api/ApiConfig";
import { asyncDebounce } from "../../utils";
import { FieldValidationParams } from "../types";
import { validationException } from "./validator.utils";

export const validateOtpFn = async (
  otp: string,
): Promise<{
  valid: boolean;
}> => {
  const req = await getDataFetcher().post("/otp", { otp });
  return req.data;
};

const debouncedValidatorFn = asyncDebounce(validateOtpFn, 400);

export const validateOtpField = async ({
  args,
  names,
  onValidated,
  onInvalid,
  onValidationStarted,
}: FieldValidationParams) => {
  return new Promise((resolve, reject) => {
    const [, value, defs, schema] = args;
    const { instancePath } = schema;
    const paths = (instancePath || "").split("/");
    const name = paths[paths.length - 1];
    const { otp = "numeric", otpLength = 6 } = defs;

    if (value.length !== otpLength) {
      if (onInvalid) {
        onInvalid(names, name, "otp", 0, [otp, otpLength]);
      }
      return reject(
        validationException(
          "otpLength",
          `At least ${otpLength} ${otp} characters are required.`,
        ),
      );
    }
    const deps = [name];

    if (onValidationStarted) {
      onValidationStarted("otp", name);
    }
    debouncedValidatorFn(value)
      .then(res => {
        if (!res.valid) {
          if (onInvalid) {
            onInvalid(names, name, "otp", 0, []);
          }
          return reject(validationException("otp", "Not valid OTP"));
        }
        if (onValidated) {
          onValidated(names, name, "otp", deps, { otp: value });
        }
        return resolve(true);
      })
      .catch(() => {
        if (onInvalid) {
          onInvalid(names, name, "otp", 500, []);
        }
        return reject(validationException("otp", "Not valid OTP"));
      });
  });
};
